import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function CeilingFan(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M12 2C9.124 2 7.134 4.872 8.144 7.565l1.395 3.72a2.99 2.99 0 00-.39.779.975.975 0 00-.072.03l-4.79 2.235a4.028 4.028 0 00-1.967 5.308c1.307 2.896 5.297 3.208 7.04.55l2.634-4.018 2.635 4.019c1.742 2.657 5.731 2.345 7.04-.55a4.028 4.028 0 00-1.968-5.309l-4.79-2.235a1.085 1.085 0 00-.058-.025 2.989 2.989 0 00-.392-.785l1.395-3.72C16.866 4.873 14.876 2 12 2zm2.74 12.222a3.01 3.01 0 01-.886 1.137L16.3 19.09c.877 1.338 2.886 1.181 3.545-.277a2.028 2.028 0 00-.991-2.672l-4.114-1.92zm-9.607 1.92l4.124-1.925c.198.447.503.836.881 1.135l-2.451 3.74c-.878 1.337-2.886 1.18-3.545-.278a2.028 2.028 0 01.99-2.672zM12.77 10.1l1.214-3.238a2.118 2.118 0 10-3.968 0L11.23 10.1a3.004 3.004 0 011.54 0zM13 13a1 1 0 11-2 0 1 1 0 012 0z",
    clipRule: "evenodd"
  }));
}

export default CeilingFan;